const translations = {
    asAppliedMapLabel: 'As Applied Map (gal/min)',
    asAppliedMapLabelGpa: 'As Applied Map (gal/acre)',
    asFlown: 'Flights',
    coverageMapLabel: 'Coverage Map',
    title: 'Map Type'
};

export default translations;
